<template>
  <div>
    <div class="page_title">医生开方活动</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="flex between">
          <div class="searchbox">
            <div>活动名称</div>
            <el-input
              v-model="act_name"
              style="width:180px;margin:0 16px 0 8px"
              @change="search"
              clearable
            />
            <div>活动状态</div>
            <el-select
              style="width:180px;margin:0 16px 0 8px"
              v-model="status"
              placeholder="请选择"
              @change="search"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              @click="search"
              type="info"
              style="background-color:#eceff2;;color:#747981;"
            >查询</el-button>
          </div>
          <el-button
            type="primary"
            @click="addActivity"
            :disabled="module_id_array[0]?!module_id_array.includes('1018'):false"
          >新增活动</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6;margin-top:10px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="act_name"
              label="活动名称"
            />
            <el-table-column
              prop="create_time"
              label="创建时间"
            />
            <el-table-column label="活动类型">
              <template slot-scope="scope">
                <div v-if="scope.row.act_type==1">开方数量活动</div>
                <div v-if="scope.row.act_type==2">开方金额活动</div>
              </template>
            </el-table-column>
            <el-table-column label="活动备注">
              <template slot-scope="scope">
                <div class="remark">{{scope.row.remark}}</div>
              </template>
            </el-table-column>

            <el-table-column label="活动时间">
              <template slot-scope="scope">
                <div>{{scope.row.start_time}} ~ {{scope.row.end_time}}</div>
              </template>
            </el-table-column>

            <el-table-column
              label="参与医生数"
              prop="doctor_num"
            >
            </el-table-column>

            <el-table-column label="活动状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status==1">未开始</div>
                <div v-if="scope.row.status==2">进行中</div>
                <div v-if="scope.row.status==3">已结束</div>
                <div v-if="scope.row.status==4">已作废</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="openUrl(scope.row.act_url)"
                >链接</el-button>
                <el-button
                  type="text"
                  @click="edit(scope.row.act_id)"
                  v-if="scope.row.status==1||scope.row.status==2"
                  :disabled="module_id_array[0]?!module_id_array.includes('1030'):false"
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="toStatistics(scope.row.act_id,scope.row.act_name,scope.row.start_time,scope.row.end_time)"
                  :disabled="module_id_array[0]?!module_id_array.includes('1019'):false"
                >统计</el-button>
                <el-button
                  v-if="scope.row.status!=4"
                  type="text"
                  @click="delActivity(scope.row.act_id,scope.row.status,scope.row.act_name)"
                  :disabled="module_id_array[0]?!module_id_array.includes('1016'):false"
                >作废</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      act_name: '',
      status: 0,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '未开始'
        },
        {
          value: 2,
          label: '进行中'
        },
        {
          value: 3,
          label: '已结束'
        },
        {
          value: 4,
          label: '已作废'
        }
      ]
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  activated() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        act_name: this.act_name,
        status: this.status,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/doctor/doctorActivityList', data)
        .then((res) => {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.start_time = dayjs.unix(item.start_time).format('YYYY-MM-DD');
            item.end_time = dayjs.unix(item.end_time).format('YYYY-MM-DD');
            return item;
          });
          this.totalNum = res.data.total;
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //新增活动
    addActivity() {
      this.$router.push('activityadd');
    },
    //编辑活动
    edit(act_id) {
      this.$router.push({
        path: 'activityedit',
        query: {
          act_id
        }
      });
    },
    //统计
    toStatistics(act_id, act_name, start_time, end_time) {
      this.$router.push({
        path: 'statisticslist',
        query: {
          act_id,
          act_name,
          start_time,
          end_time
        }
      });
    },
    //作废
    delActivity(act_id, status, act_name) {
      if (status == 1) {
        this.$confirm(
          `确定作废活动【${act_name}】吗？作废后将无法恢复`,
          '提示',
          {
            confirmButtonText: '确定作废',
            cancelButtonText: '取消'
          }
        )
          .then(() => {
            this.axios
              .post('platform/doctor/isCancelDoctorActivity', {
                act_id
              })
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('操作成功');
                  this.getList();
                }
              });
          })
          .catch(() => {});
      }
      if (status == 2) {
        this.$message.error(`活动【${act_name}】正在进行中，无法作废`);
        return false;
      }
      if (status == 3) {
        this.$message.error(`活动【${act_name}】已经结束，无法作废`);
        return false;
      }
    },
    //打开链接
    openUrl(act_url) {
      this.$confirm(act_url, '链接', {
        confirmButtonText: '复制',
        cancelButtonText: '取消'
      })
        .then(() => {
          let oInput = document.createElement('input');
          oInput.value = act_url;
          document.body.appendChild(oInput);
          oInput.select();
          document.execCommand('Copy');
          oInput.remove();
          this.$message({
            message: '复制成功',
            type: 'success'
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.remark {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



